import { TextBadge } from '@/components/DesignSystem';
import { Stack, useTheme } from '@mui/material';
import React from 'react';

export const IntegrationImportFailureBadge = () => {
  const theme = useTheme();
  return (
    <Stack width="fit-content">
      <TextBadge
        backgroundColor={theme.palette.error.main}
        text="Integration import failure"
      />
    </Stack>
  );
};
